import { render, staticRenderFns } from "./Produktgruppe.vue?vue&type=template&id=570ca026"
import script from "./Produktgruppe.vue?vue&type=script&lang=js"
export * from "./Produktgruppe.vue?vue&type=script&lang=js"
import style0 from "./Produktgruppe.vue?vue&type=style&index=0&id=570ca026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports